export const getValidUrl = (url: string) => {
  if (url.charAt(url.length - 1) === '/') {
    return url.slice(0, -1);
  }

  return url;
};

export const getHubBasePath = (url: string) => {
  const hub = url.split('/')[1];

  return `/${hub}`;
};
